import { render, staticRenderFns } from "./mycommodities.vue?vue&type=template&id=2e4c7271&"
import script from "./mycommodities.vue?vue&type=script&lang=js&"
export * from "./mycommodities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports